module.exports = __webpack_public_path__ + "img/stock5.0263edb2.png";